var map = {
	"./App": "xYwX",
	"./App.jsx": "xYwX",
	"./Category/Breadcrumbs": "WGQB",
	"./Category/Breadcrumbs.jsx": "WGQB",
	"./Category/Breadcrumbs.scss": "0rDB",
	"./Category/Category": "ChPX",
	"./Category/Category.jsx": "ChPX",
	"./Category/Category.scss": "dJIz",
	"./Category/ProductItem": "kTyy",
	"./Category/ProductItem.jsx": "kTyy",
	"./Category/ProductItem.scss": "BOsu",
	"./Category/ProductList": "TdU9",
	"./Category/ProductList.jsx": "TdU9",
	"./Category/ProductList.scss": "UekF",
	"./Category/selectAnalytics": "Hrpc",
	"./Category/selectAnalytics.js": "Hrpc",
	"./Elements/Button/Button": "CwcU",
	"./Elements/Button/Button.jsx": "CwcU",
	"./Elements/Button/Button.scss": "4gwF",
	"./Elements/Checkbox/Checkbox": "DLGd",
	"./Elements/Checkbox/Checkbox.jsx": "DLGd",
	"./Elements/Checkbox/Checkbox.scss": "B/bj",
	"./Elements/FakeSelect/FakeSelect": "mkyd",
	"./Elements/FakeSelect/FakeSelect.jsx": "mkyd",
	"./Elements/FakeSelect/FakeSelect.scss": "8s1T",
	"./Elements/Input/Input": "jHNd",
	"./Elements/Input/Input.jsx": "jHNd",
	"./Elements/Input/Input.scss": "riYQ",
	"./Elements/Radio/Radio": "l+Hx",
	"./Elements/Radio/Radio.jsx": "l+Hx",
	"./Elements/Radio/Radio.scss": "Eivg",
	"./Elements/Select/Select": "qN6N",
	"./Elements/Select/Select.jsx": "qN6N",
	"./Elements/Select/Select.scss": "T8fd",
	"./Elements/TextBackgrounds/TextBackgrounds": "nJmO",
	"./Elements/TextBackgrounds/TextBackgrounds.jsx": "nJmO",
	"./Footer/Footer": "s4cb",
	"./Footer/Footer.jsx": "s4cb",
	"./Footer/Footer.scss": "64fX",
	"./Footer/Newsletter": "cyW4",
	"./Footer/Newsletter.jsx": "cyW4",
	"./Footer/Newsletter.scss": "Ve0s",
	"./Footer/swedish-flag.svg": "gRmr",
	"./Header/Header": "Xhe4",
	"./Header/Header.jsx": "Xhe4",
	"./Header/Header.scss": "pr76",
	"./Header/InternalNavigation": "xjur",
	"./Header/InternalNavigation.jsx": "xjur",
	"./Header/InternalNavigation.scss": "pQ/x",
	"./Header/Navigation": "bPW0",
	"./Header/Navigation.jsx": "bPW0",
	"./Header/Navigation.scss": "SFSM",
	"./Header/Notification": "xg2N",
	"./Header/Notification.jsx": "xg2N",
	"./Header/Notification.scss": "Mrf/",
	"./Page/Page": "+4EV",
	"./Page/Page.jsx": "+4EV",
	"./Page/Page.scss": "ml7l",
	"./Product/Price": "YaRM",
	"./Product/Price.jsx": "YaRM",
	"./Product/Price.scss": "X1Pd",
	"./Product/Product": "lAbh",
	"./Product/Product.jsx": "lAbh",
	"./Product/Product.scss": "9jDO",
	"./Product/Purchase": "jt4R",
	"./Product/Purchase.jsx": "jt4R",
	"./Product/Purchase.scss": "1kBh",
	"./Product/SizeChart": "r6bF",
	"./Product/SizeChart.jsx": "r6bF",
	"./Product/SizeChart.scss": "GdcX",
	"./Product/email.svg": "m2tS",
	"./Product/facebook.svg": "am0c",
	"./Product/pinterest.svg": "MXzO",
	"./Product/twitter.svg": "A73J",
	"./Product/viewAnalytics": "P1eq",
	"./Product/viewAnalytics.js": "P1eq",
	"./Selection/Cart": "+MmZ",
	"./Selection/Cart.jsx": "+MmZ",
	"./Selection/Cart.scss": "bKry",
	"./Selection/CartAddOns": "pstG",
	"./Selection/CartAddOns.jsx": "pstG",
	"./Selection/CartAddOns.scss": "sz9/",
	"./Selection/CartItems": "/3B3",
	"./Selection/CartItems.jsx": "/3B3",
	"./Selection/CartItems.scss": "tlIR",
	"./Selection/KlarnaCheckout": "1Tad",
	"./Selection/KlarnaCheckout.jsx": "1Tad",
	"./Selection/Receipt": "VOw1",
	"./Selection/Receipt.jsx": "VOw1",
	"./Selection/Receipt.scss": "nRAG",
	"./Selection/Selection": "BpyM",
	"./Selection/Selection.jsx": "BpyM",
	"./Selection/Selection.scss": "p9qy",
	"./Selection/Totals": "oREl",
	"./Selection/Totals.jsx": "oREl",
	"./Selection/Totals.scss": "0ghi",
	"./Selection/cartAnalytics": "IV/1",
	"./Selection/cartAnalytics.js": "IV/1",
	"./Selection/checkoutAnalytics": "dSmd",
	"./Selection/checkoutAnalytics.js": "dSmd",
	"./Selection/receiptAnalytics": "jTM1",
	"./Selection/receiptAnalytics.js": "jTM1",
	"./Switcher": "bcPK",
	"./Switcher.jsx": "bcPK",
	"./Templates/BackgroundMedia/BackgroundMedia": "BTkN",
	"./Templates/BackgroundMedia/BackgroundMedia.jsx": "BTkN",
	"./Templates/BackgroundMedia/BackgroundMedia.scss": "Lohu",
	"./Templates/Button/Button": "MJgw",
	"./Templates/Button/Button.jsx": "MJgw",
	"./Templates/Countdown/Countdown": "7aeG",
	"./Templates/Countdown/Countdown.jsx": "7aeG",
	"./Templates/Countdown/Countdown.scss": "beYz",
	"./Templates/Customizer/Customizer": "Xbp8",
	"./Templates/Customizer/Customizer.jsx": "Xbp8",
	"./Templates/Customizer/Customizer.scss": "U4q2",
	"./Templates/Embed/Embed": "0x2a",
	"./Templates/Embed/Embed.jsx": "0x2a",
	"./Templates/Embed/Embed.scss": "EQMK",
	"./Templates/File/File": "nuOU",
	"./Templates/File/File.jsx": "nuOU",
	"./Templates/File/File.scss": "G7pb",
	"./Templates/FreeHTML/FreeHTML": "A+2D",
	"./Templates/FreeHTML/FreeHTML.jsx": "A+2D",
	"./Templates/Heading/Heading": "hnIk",
	"./Templates/Heading/Heading.jsx": "hnIk",
	"./Templates/Heading/Heading.scss": "Ps+a",
	"./Templates/Image/Image": "eifF",
	"./Templates/Image/Image.jsx": "eifF",
	"./Templates/Image/Image.scss": "LkpZ",
	"./Templates/Instagram/Instagram": "OOMk",
	"./Templates/Instagram/Instagram.jsx": "OOMk",
	"./Templates/Instagram/Instagram.scss": "sC//",
	"./Templates/List/List": "zHll",
	"./Templates/List/List.jsx": "zHll",
	"./Templates/List/List.scss": "wJ0o",
	"./Templates/Media/Media": "2Lv0",
	"./Templates/Media/Media.jsx": "2Lv0",
	"./Templates/Media/Media.scss": "pPUH",
	"./Templates/Paragraph/Paragraph": "T0hq",
	"./Templates/Paragraph/Paragraph.jsx": "T0hq",
	"./Templates/Paragraph/Paragraph.scss": "unjF",
	"./Templates/Placeholder/Placeholder": "JXbr",
	"./Templates/Placeholder/Placeholder.jsx": "JXbr",
	"./Templates/Products/Products": "spN4",
	"./Templates/Products/Products.jsx": "spN4",
	"./Templates/Products/Products.scss": "GcNI",
	"./Templates/Separator/Separator": "By69",
	"./Templates/Separator/Separator.jsx": "By69",
	"./Templates/Separator/Separator.scss": "moDU",
	"./Templates/SizeSelector/SizeSelector": "h5MM",
	"./Templates/SizeSelector/SizeSelector.jsx": "h5MM",
	"./Templates/SizeSelector/SizeSelector.scss": "zFvn",
	"./Templates/SizeSelector/components/FootIcon": "eWAQ",
	"./Templates/SizeSelector/components/FootIcon.jsx": "eWAQ",
	"./Templates/SizeSelector/components/ResultPresentation": "vZML",
	"./Templates/SizeSelector/components/ResultPresentation.jsx": "vZML",
	"./Templates/Spacer/Spacer": "S/nj",
	"./Templates/Spacer/Spacer.jsx": "S/nj",
	"./Templates/Spacer/Spacer.scss": "Dfjq",
	"./Templates/Stockists/Stockists": "1sVc",
	"./Templates/Stockists/Stockists.jsx": "1sVc",
	"./Templates/Stockists/Stockists.scss": "iu44",
	"./Templates/Table/Table": "SPDT",
	"./Templates/Table/Table.jsx": "SPDT",
	"./Templates/Table/Table.scss": "eerd",
	"./Templates/TemplateParser": "Djad",
	"./Templates/TemplateParser.jsx": "Djad",
	"./Templates/TemplateParser.scss": "5cCJ",
	"./Templates/TemplateParserDeprecated": "Le8W",
	"./Templates/TemplateParserDeprecated.jsx": "Le8W",
	"./Templates/TemplateParserDeprecated.scss": "4dWG",
	"./Templates/Text/Text": "wdR2",
	"./Templates/Text/Text.jsx": "wdR2",
	"./Templates/Text/Text.scss": "a+8p",
	"./Templates/TrustBox/TrustBox": "CojF",
	"./Templates/TrustBox/TrustBox.jsx": "CojF",
	"./Templates/Video/Video": "BjCw",
	"./Templates/Video/Video.jsx": "BjCw",
	"./Templates/Video/Video.scss": "0DCv",
	"./Templates/VideoEmbed/VideoEmbed": "JYug",
	"./Templates/VideoEmbed/VideoEmbed.jsx": "JYug",
	"./Templates/VideoEmbed/VideoEmbed.scss": "HzcL",
	"./Top/Top": "7su/",
	"./Top/Top.jsx": "7su/",
	"./UniversalComponent": "IO1V",
	"./UniversalComponent.jsx": "IO1V"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "jdtg";
module.exports = webpackContext;